import Parse from 'parse';
import CONFIG_HELPER from './../../ConfigHelper';
import moment from "moment-timezone";
import _ from "lodash";

module.exports ={

    // fetchParseConfig() {
    //     return Parse.Config.get();
    // },

    mapObject(object, callback) {
        return Object.keys(object).map(function (key) {
            return callback(key, object[key]);
        });
    },

    chunk(arr, len) {

        var chunks = [],
            i = 0,
                n = arr.length;

                while (i < n) {
                    chunks.push(arr.slice(i, i += len));
                }

                return chunks;
    },

    isEmpty(str) {
    	return (!str || 0 === str.length);
    },

    isEmptyWithTrim(str) {
    	return (!str.trim());
    },

    isEmptyObj(obj) {
        if (!obj) {
             return true;
        }

        return Object.getOwnPropertyNames(obj).length === 0;
    },

    getCurrentDayLong() {
        var d = new Date();
        var days
            = [
                "Sunday","Monday","Tuesday",
                "Wednesday","Thursday","Friday","Saturday"
                ];
        return days[d.getDay()];
    },

    getCurrentDayShort(){
        var d = new Date();
        var days
            = [
                "Sun","Mon","Tue",
                "Wed","Thu","Fri","Sat"
                ];
        return days[d.getDay()];
    },

    parseTime(timeStr, dt) {

        var re1     = '(\\d+)';	// Integer Number 1
        var re2     = '(?:\\:)';	// Any Single Character 1
        var re3     = '(\\d+)';	// Integer Number 2
        var re4     = '(?:\\s*)';	// White Space 1
        var re5     = '(am|AM|pm|PM)';// Word 1

        var pattern = new RegExp(re1+re2+re3+re4+re5,["i"]);

        if (!dt) {
            dt = new Date();
        }

        var timeMatch = pattern .exec(timeStr);

        if (!timeMatch) {
            return NaN;
        }
        var hours = parseInt(timeMatch [1], 10);
        var AMPM = timeMatch [3];

        if(AMPM == "PM" && hours<12) hours = hours+12;
        if(AMPM == "AM" && hours==12) hours = hours-12;

        dt.setHours(hours);
        dt.setMinutes(parseInt(timeMatch [2], 10) || 0);
        dt.setSeconds(0, 0);
        return dt;
    },

    dateToHours(date){
        var hours             = date.getHours();
        var minutes           = date.getMinutes();
        var suffix            = (hours >= 12)? 'PM' : 'AM';
        var hh                = ((hours + 11) % 12 + 1);
        var mm                = (minutes < 10 ? "0" : "") + minutes;
        var formattedTime     = hh + ":" + mm + " " + suffix;
        return formattedTime;
    },

    calcTime(offset) {

        let d = new Date();
        //Deal with dates in milliseconds for most accuracy
        let utc = d.getTime() + (d.getTimezoneOffset() * 60000);
        let newDateWithOffset = new Date(utc + (3600000*offset));
        return newDateWithOffset.toLocaleString();

    },

    //Filtering based on object keys
    filter( obj, predicate) {
        var result = {}, key;
        for (key in obj) {
            if (obj.hasOwnProperty(key) && predicate(key)) {
                result[key] = obj[key];
            }
        }
        return result;
    },

    getTodaysOpeningDetails(openHours){
        return this.filter(openHours,function(key){
            var today = this.getCurrentDayShort();
            return today.toUpperCase() === key.toUpperCase();
        }.bind(this));
    },

    getTodaysOpeningHours(openHours){

        var todaysOpeningHour = this.filter(openHours,function(key){
            var today = this.getCurrentDayShort();
            return today.toUpperCase() === key.toUpperCase();
        }.bind(this));

        return todaysOpeningHour[this.getCurrentDayShort().toUpperCase()];
    },

    isResturantOpen(openHours){

        var todaysOpeningHour = this.filter(openHours,function(key){
            var today = this.getCurrentDayShort();
            return today.toUpperCase() === key.toUpperCase();
        }.bind(this));

        var timeRanges = todaysOpeningHour[this.getCurrentDayShort().toUpperCase()].split("|");

        var individualHours
        = timeRanges.map(function(timeRange){
            return timeRange.split("-").map(function(time){
                return this.parseTime(time);
            }.bind(this))
        }.bind(this));

        return individualHours.some(function(individualHour){
            var today = new Date();
            return individualHour[0]<=today && today <= individualHour[1];
        });
    },

    getNum(val){
        if (!val) {
            return 0;
        }
        return val;
    },

    round(value, decimals) {
        return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
    },

    formatPhoneNumber(value) {
        // if input value is falsy eg if the user deletes the input, then just return
        if (!value) return value;

        // clean the input for any non-digit values.
        const phoneNumber = value.replace(/[^\d]/g, "");

        // phoneNumberLength is used to know when to apply our formatting for the phone number
        const phoneNumberLength = phoneNumber.length;

        // we need to return the value with no formatting if its less then four digits
        // this is to avoid weird behavior that occurs if you  format the area code to early
        if (phoneNumberLength < 4) return phoneNumber;

        // if phoneNumberLength is greater than 4 and less the 7 we start to return
        // the formatted number
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }

        // finally, if the phoneNumberLength is greater then seven, we add the last
        // bit of formatting and return it.
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
            3,
            6
        )}-${phoneNumber.slice(6, 10)}`;
        // }
    },

    getAddressStrFromLocation(locationBar) {
        let address = "";
        if (locationBar != null) {
            address = `${locationBar.addLine1} ${locationBar.addLine2 || ''} ,
            \n ${locationBar.city}, ${locationBar.state} - ${locationBar.zipCode},
            ${this.formatPhoneNumber(locationBar.phoneNumber)}`;
        }
        return address;
    },

    generateRandom(num = 5){
        const s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        return Array.apply(null, Array(num)).map(function() { return s.charAt(Math.floor(Math.random() * s.length)); }).join('');
    },

    updateUserAcl(user) {
        let currentUser = null;
        if(!user) {
            currentUser = Parse.User.current();
        } else {
            currentUser = user;
        }
        if (!currentUser) {
            return;
        }
        const oldAcl = currentUser.getACL();
        if(!oldAcl || oldAcl.getPublicReadAccess() || oldAcl.getPublicWriteAccess()) {
            const acl = new Parse.ACL(currentUser);
            currentUser.setACL(acl);
            return currentUser.save();
        } else {
             return Parse.Promise.as(currentUser);
        }
    },
    toRoundStr(number, precision) {
        return _.round(number, precision).toFixed(precision);
    },

    decimalCount(number) {
        // Convert to String
        const numberAsString = number.toString();
        // String Contains Decimal
        if (numberAsString.includes('.')) {
            return numberAsString.split('.')[1].length;
        }
        // String Does Not Contain Decimal
        return 0;
    },

    number2digit(number){
        var numberData = new Intl.NumberFormat(undefined, {minimumFractionDigits:2, maximumFractionDigits: 3 }).format(number);
        return numberData;
    },

    calculateStripeFee(totalAmount) {

        const stripeChargePercentage = CONFIG_HELPER.STRIPE_PERCENTAGE;
        const stripeChargeCents = CONFIG_HELPER.STRIPE_CENTS;

        let totalStripeFee = ((totalAmount * stripeChargePercentage) / 100) + stripeChargeCents;

        return this.toRoundStr(totalStripeFee, 2);
    },

    calculateNetTotalStripeFee(totalAmount) {

        let stripeFee = this.calculateStripeFee(totalAmount);

        let netTotalStripFee = totalAmount - stripeFee;

        return this.toRoundStr(netTotalStripFee, 2);

    },

    // calculate the array key sum
    sumProperty(arr, type) {
        return arr.reduce((total, obj) => {
            if (typeof obj[type] === 'string') {
                return total + Number(obj[type]);
            }
            return total + obj[type];
        }, 0);
    },

    formatDateTimeWithTimeZone(date, timeZone, locale = "en-us",) {
        const options = {
            timeZone: timeZone,
            weekday : "long", year : "numeric", month : "short",
            day     : "numeric", hour : "2-digit", minute : "2-digit"
        };

        // console.log(options);

        let formattedTime = "";

        if (date != null) {
            formattedTime = date.toLocaleTimeString(locale, options);
        }

        return formattedTime;
    },

    getUTCdateTime(date, timeZone){

        if (!date) {
            date = new Date();
        }

        let formatDateTime = this.formatDateTimeWithTimeZone(date, timeZone);

        let utcDateTime = moment(formatDateTime).toISOString();
       // let utcDateTime = formatDateTime.toISOString();
       //  console.log(utcDateTime);

        return utcDateTime;

    },

    getDateJson(dateString) {

        return {
            "__type" : "Date",
            "iso"    : dateString
        };
    },

    getDateString(date, timeZone){
        // return moment(date).format("YYYY-MM-DD");

        return  moment.tz(date, timeZone).local().format('YYYY-MM-DD');
    },

    getDateFromDateObj(dateObj){
        // var dateObj = new Date();
        var month = dateObj.getMonth() + 1; //months from 1-12
        var day = dateObj.getDate();
        var year = dateObj.getFullYear();

        let dateString = year + "/" + month + "/" + day;
        return dateString;
    },

    logOut(router) {
        Parse.User.logOut().then(
            (success) => {
                Parse.User._clearAllState();
                Parse.User._clearCache();
                router.push('/');
            },
            (error) => {
                if (error.code === Parse.Error.INVALID_SESSION_TOKEN) {
                    router.push('/');
                }
            }
        );
    },
    // check the error message and show the alert box
    checkErrorIsInvalidSessionToken(error,router) {
        console.log("Error:" + JSON.stringify(error));
        if (error != null && error.responseJSON != null && error.responseJSON.error != null) {
            let errorCode = error.responseJSON.error.code;
            let errorMessage = error.responseJSON.error.message;
            if (errorCode == Parse.Error.INVALID_SESSION_TOKEN) {
                alert(errorMessage);
                this.logOut(router);
            }
        } else if (error != null && error.code != null) {
            let errorCode = error.code;
            let errorMessage = error.message;
            if (errorCode == Parse.Error.INVALID_SESSION_TOKEN) {
                alert(errorMessage);
                this.logOut(router);
            }
        }
    },

    // check the session is valid or not
    isUserSessionInvalid() {
        return Parse.Session.current();
    },
    isDeliveryOrder(order){

        let orderType = order.orderType;
        if(orderType == "Delivery"){
            return true;
        }
        else {
            return false;
        }

    },

    isCurbsidePickup(order){

        let isCurbside = false
        if (!this.isEmptyObj(order.curbsidePickup)){

            let curbsidePickup = order.curbsidePickup;
            if (!this.isEmpty(curbsidePickup.vMakeModel) && !this.isEmpty(curbsidePickup.vColor)){
                isCurbside = true;
            }
            else {
                isCurbside = false;
            }
        }
        return isCurbside;
    },

    getOrderTypeStr(order){

        let orderType = order.orderType;
        if(orderType == "PickUp" && this.isCurbsidePickup(order)){

            return "Curbside Pickup";
        }

        return orderType;
    },
    extractTimeZoneFromLocation(activeLocation) {

        let timeZone = null;
        if (activeLocation) {
            timeZone = activeLocation.timeZone;
        }

        return timeZone;
    },
    isGroupShownAfterHours(groupDetail) {
        let defaultGroupVisible = true;

        if (groupDetail != null){

            if (groupDetail.hideAfterHours && groupDetail.openHours != null){

                let groupOpenHours = groupDetail.openHours;
                let currentTime = new Date();

                let isGroupAvailable = this.isResturantOpen(groupOpenHours,currentTime);

                return isGroupAvailable;

            }

        }
        return defaultGroupVisible;
    },
    getPointerFor(pointerName, objectId) {
        let pointer = {
            "__type": "Pointer",
            "objectId": objectId,
            "className": pointerName
        };

        return pointer;
    },
    removeSpecialCharsFromString(name){

        let newString = name.replace(/[^A-Z0-9]+/ig, "_");

        return newString;
    },

    getChargeFullName(chargeType){

        switch(chargeType) {
            case 'O':
                return 'Optional';
            case 'R':
                return 'RoundUp';
            case 'F':
                return 'Fixed';
            default:
                return 'Null';
        }
    },
    getChargeTypeKey(chargeType){

        switch(chargeType) {
            case 'O':
                return 'optional';
            case 'R':
                return 'roundUp';
            case 'F':
                return 'fixed';
            default:
                return 'Null';
        }
    },
    getChargeShortName(chargeType){

        switch(chargeType) {
            case 'optional':
                return 'O';
            case 'roundUp':
                return 'R';
            case 'fixed':
                return 'F';
            default:
                return 'Null';
        }
    },
    extractWebsiteConfig(websiteConfig, property) {
        if (!this.isEmptyObj(websiteConfig) && (!this.isEmptyObj(websiteConfig[property]) || websiteConfig[property])) {
            return websiteConfig[property];
        }
        return null;
    },
    isMobileDevice() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    },

    //convert miles to meters.
    convertMilesToMeters(deliveryRange) {

        let deliveryDistanceInMiles = 0;

        if (!this.isEmpty(deliveryRange)) {
            deliveryDistanceInMiles = _.round(deliveryRange * 1609, 2);
        }

        return deliveryDistanceInMiles;
    },

    //convert meters to miles.
    convertMetersToMiles(deliveryRange) {
        let deliveryDistanceInMiles = 0;

        if (!this.isEmpty(deliveryRange)) {
            deliveryDistanceInMiles = _.round(deliveryRange / 1609, 2);
        }

        return deliveryDistanceInMiles;
    },

    scrollToTop(elementId){
        let elem = document.getElementById(elementId);

        if(elem){
            elem.scrollIntoView({
                block: 'center',
                behavior: "smooth"
            });
        }
    }

}




// WEBPACK FOOTER //
// src/Utils/Utility.js